
import { HeroSection } from "@/components/HeroSection";
import { TechSection } from "@/components/TechSection";
import { ResearchSection } from "@/components/ResearchSection";
import { TeamSection } from "@/components/TeamSection";
import { CareersSection } from "@/components/CareersSection";
import { ContactForm } from "@/components/ContactForm";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <div className="radial-gradient-bg">
          <HeroSection />
        </div>
        <div>
          <TechSection />
        </div>
        <div className="radial-gradient-bg">
          <ResearchSection />
        </div>
        <div>
          <TeamSection />
        </div>
        <div>
          <CareersSection />
        </div>
        <div className="radial-gradient-bg" id="contact">
          <ContactForm />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
